export const PRICE_TRENDS_HEATMAP_GRID_STYLES = {
  root: "w-full rounded-[16px] bg-white p-6 shadow-ticketon-card",
  header: "mb-4 flex flex-col gap-1",
  title: "text-[18px] md:text-[22px] font-bold text-ticketon-dark-blue",
  description: "text-[13px] md:text-[14px] text-ticketon-gray-600",
  grid: "grid gap-2",
  gridCols: {
    3: "grid-cols-3",
    4: "grid-cols-2 sm:grid-cols-4",
    6: "grid-cols-3 sm:grid-cols-6",
  },
  cell: "relative flex flex-col items-center justify-center gap-1 rounded-lg border border-ticketon-light-border px-3 py-4 text-center transition-shadow hover:shadow-ticketon-card",
  cellMonth: "text-[12px] md:text-[13px] font-semibold uppercase tracking-wide",
  cellPrice: "text-[14px] md:text-[16px] font-bold tabular-nums",
  ribbon:
    "absolute -top-2 left-1/2 -translate-x-1/2 inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold text-white shadow-sm",
  ribbonMin: "bg-ticketon-green",
  ribbonMax: "bg-ticketon-red-alt",
} as const;

export const PRICE_TRENDS_HEATMAP_GRID_HUE_MIN = 140;
export const PRICE_TRENDS_HEATMAP_GRID_HUE_MAX = 0;
